module.exports = __webpack_public_path__ + "media/images/blank-0d23d0b6.gif";